var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94608 14.339C1.55685 14.339 1.29736 14.0795 1.29736 13.6903V7.85184C1.29736 7.46261 1.55685 7.20312 1.94608 7.20312C2.33531 7.20312 2.5948 7.46261 2.5948 7.85184V13.6903C2.5948 14.0795 2.33531 14.339 1.94608 14.339Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5585 14.988H5.21549C4.13416 14.988 3.24365 14.0798 3.24365 12.977V7.52777C3.24365 6.81418 3.49808 6.16547 3.94334 5.58162L6.48765 2.66239C6.8693 2.27316 7.44176 2.01367 8.07784 2.01367C8.77753 2.01367 9.35 2.33803 9.73164 2.85701C10.1133 3.44085 10.2405 4.08957 10.0497 4.73829L9.66804 5.97085H12.3396C12.9756 5.97085 13.5481 6.23034 13.8661 6.74931C14.2478 7.26829 14.375 7.917 14.1842 8.50085L12.8484 13.1067C12.5304 14.2744 11.6399 14.988 10.5585 14.988ZM4.96106 6.48983C4.70663 6.81418 4.57942 7.13854 4.57942 7.52777V12.977C4.57942 13.3662 4.89745 13.6906 5.2791 13.6906H10.6222C11.131 13.6906 11.5763 13.3662 11.7035 12.8473L12.9756 8.24136C13.0392 8.04675 12.9756 7.78726 12.8484 7.59265C12.7212 7.39803 12.5304 7.33316 12.3396 7.33316H8.77753C8.5867 7.33316 8.39588 7.20341 8.26867 7.07367C8.14145 6.94393 8.14145 6.68444 8.20506 6.48983L8.90474 4.34906C8.96835 4.08957 8.96835 3.83008 8.77753 3.63547C8.5231 3.24624 7.88702 3.18136 7.56898 3.57059L4.96106 6.48983Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.7e90837e220e29ecbd7a8840cecefcd5.svg";
export { ForwardRef as ReactComponent };